export const enum AuditState {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  WAITING = 'WAITING'
}
// 列表
export interface ITableType {
  name?: string; // 部门名称
  type?: string; // 类型 0 公司 1部门
  pid?: number; // 上级部门ID
  sort?: string; // 排序序号 数字越大排序越靠后
  code?: string; // 编号
}

export const defaultValue: Readonly<ITableType> = {};

// 搜索表单
export interface ISearchForm {
  name?: string;
}

export const defaultSearchForm: ISearchForm = {
  name: ''
};
